// @flow
import type { State } from './interfaces';

export const versions = (): Array<string> => [];
export const navPinned = (): boolean => false;
export const showPrivateAPI = (): boolean => false;

export const state = (): State => ({
  versions: versions(),
  navPinned: navPinned(),
  showPrivateAPI: showPrivateAPI()
});



// WEBPACK FOOTER //
// ./src/reducers/app/defaultValues.js